<template>
  <v-container fluid class="pa-0 new-details-container">
    <breadcrumbs-banner :bannerTitle="$t('header.news')"></breadcrumbs-banner>
    <v-container class="py-lg-16 pa-10 pa-sm-14 px-lg-3">
      <v-row>
        <v-col cols="12" lg="9" class="pr-lg-16">
          <v-row class="py-5">
            <v-col cols="12" class="d-flex flex-column">
              <h4 class="text-lg-h4 text-h5 text-navy font-weight-bold">
                {{ newDetails.title }}
              </h4>
              <p class="text-gray font-weight-light border-top-gray pt-5">
                <span class="float-left mr-2">
                  <v-img src="/calendar.svg" width="21"></v-img>
                </span>
                {{ moment(newDetails.publication_date).format("LL") }}
              </p>

              <v-img
                :src="newDetails.upload.path"
                height="340"
                class="rounded-lg"
              ></v-img>
              <p
                class="text-navy mt-5 font-weight-light"
                v-html="newDetails.description"
              ></p>
              <v-row class="mt-lg-10">
                <v-col cols="6">
                  <v-btn
                    v-if="newsIndex > 0"
                    class="
                      text-navy
                      font-weight-bold
                      text-capitalize text-lg-h6
                      elevation-0
                      rounded-0
                      not-background
                      px-0
                      mt-lg-4
                      justify-start
                    "
                    @click="previous()"
                    width="160"
                  >
                    {{ $t("news.previous") }}
                  </v-btn>
                </v-col>
                <v-col cols="6" class="d-flex justify-end">
                  <v-btn
                    v-if="newsIndex + 1 < news.length"
                    class="
                      text-navy
                      font-weight-bold
                      text-capitalize text-lg-h6
                      elevation-0
                      rounded-0
                      not-background
                      px-0
                      mt-lg-4
                      justify-end
                    "
                    width="160"
                    @click="next()"
                  >
                    {{ $t("news.next") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="3" class="pt-lg-16 pl-lg-5">
          <h5
            class="text-navy text-h5 text-uppercase font-weight-bold mb-5 mt-2"
          >
            {{ $t("news.lastNews") }}
          </h5>
          <v-row
            v-for="(newItem, index) in news.slice(0, 6)"
            :key="index"
            class="pt-lg-5 mx-0 border-top-gray"
          >
            <router-link :to="'/news/' + newItem.slug">
              <v-col cols="12" class="d-flex flex-column px-0">
                <h6 class="text-lg-h6 text-navy font-weight-bold">
                  {{ newItem.title }}
                </h6>
                <p class="text-gray font-weight-light mt-lg-2">
                  <span class="float-left mr-2">
                    <v-img src="/calendar.svg" width="21"></v-img>
                  </span>
                  {{ moment(newItem.publication_date).format("LL") }}
                </p>
              </v-col>
            </router-link>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <featured-articles class="px-sm-10 px-lg-0"></featured-articles>
  </v-container>
</template>
<script>
import featuredArticles from "../components/featuredArticles.vue";
import New from "../services/new";
export default {
  name: "NewDetails",
  data() {
    return {
      news: [],
      newDetails: [],
    };
  },
  components: {
    featuredArticles,
  },
  watch: {
    $route: {
      immediate: true,
      async handler() {
        this.news = await New.getNews();
        this.newDetails = this.news.find(
          (n) => n.slug === this.$route.params.slug
        );
      },
    },
  },
  async created() {},
  computed: {
    newsIndex() {
      return this.news.indexOf(this.newDetails);
    },
  },
  methods: {
    loadMore() {
      this.num = this.num + 3;
    },
    next() {
      const nextElement = this.news[this.newsIndex + 1] || this.newDetails;
      this.$router.push("/news/" + nextElement.slug);
    },
    previous() {
      const previousElement = this.news[this.newsIndex - 1] || this.newDetails;
      this.$router.push("/news/" + previousElement.slug);
    },
  },
};
</script>
